import { inject, Injectable } from '@angular/core'
import { environment } from '@environments/environment'
import { ConfigInterface } from '@ui-core/interfaces/config.interface'
import { MenuItem } from 'primeng/api'
import { UI_MENU } from '../constants/menu.constant'
import { ApiUrlService } from './api-url.service'
import { MenuService } from './menu.service'

@Injectable({
    providedIn: 'root',
})
export class InitService {
    private apiUrlService = inject(ApiUrlService)
    private menuService = inject(MenuService)

    initApiUrl(): this {
        this.apiUrlService.setApiUrl(environment.apiUrl || '')
        return this
    }

    initMenu(): this {
        const menu = UI_MENU as MenuItem[]
        this.menuService.set(menu)

        return this
    }

    getConfig(): ConfigInterface {
        return environment
    }
}
